export const AlertType = {
  default: "default",
  success: "success",
  info: "info",
  warning: "warning",
  danger: "danger",
}
